import { useParams } from 'react-router-dom';
import NavBar from './Components/NavBar';
import useTestStartPage from './Hooks/useTestStartPage';
import { TestStartContainer } from './test-start.styled';
import Questionnaire from './Components/QuestionPaper/Questionnaire';
import Calification from './Components/Calification/Calification';

interface ParamsProps {
  lessonId?: string;
}

export default function TestStart() {
  const { lessonId } = useParams<ParamsProps>();

  const { onSubmit, questions, calification, lesson, configuration } = useTestStartPage(lessonId);

  return (
    <TestStartContainer>
      <NavBar title={lesson?.name} />
      {!calification ? (
        <Questionnaire questions={questions} onSubmit={onSubmit} configuration={configuration} />
      ) : (
        <Calification calification={calification} />
      )}
    </TestStartContainer>
  );
}
